import script from "./ImpactIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpactIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./ImpactIndicator.vue?vue&type=style&index=0&id=3f37a526&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f37a526"]])

export default __exports__